export default "__VITE_ASSET__DbIyaA8E__"